module.exports = __webpack_public_path__ + "img/rura-szesciokatna.1a2d8c4c.jpg";